// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes SpinnerCircle-module_preloaderAnimation__mPyAJ {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.SpinnerCircle-module_spinner__vQSG5 {
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: SpinnerCircle-module_preloaderAnimation__mPyAJ;
    animation-timing-function: linear;
    width: 80px;
    height: 80px;
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/common/SpinnerCircle.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,8DAAkC;IAClC,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB","sourcesContent":["@keyframes preloaderAnimation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.spinner {\n    animation-duration: 1.5s;\n    animation-iteration-count: infinite;\n    animation-name: preloaderAnimation;\n    animation-timing-function: linear;\n    width: 80px;\n    height: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `SpinnerCircle-module_spinner__vQSG5`,
	"preloaderAnimation": `SpinnerCircle-module_preloaderAnimation__mPyAJ`
};
export default ___CSS_LOADER_EXPORT___;
